import { WHITE } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
var styles = StyleSheet.create({
  container: {
    backgroundColor: WHITE,
    flex: 1
  },
  itemText: {
    fontSize: 16
  },
  itemWrapper: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center'
  },
  selectorView: {
    borderBottomWidth: 1,
    borderColor: WHITE,
    borderTopWidth: 1,
    position: 'absolute'
  }
});
export default styles;